import React from 'react'
import { Navigate } from 'react-router-dom';

const ProtectedRoutes = ({component: Component, ...rest}) => {
  const accessToken = localStorage.getItem("token");
return accessToken ? <Component {...rest}/> : <Navigate to = '/login' replace/>
}

export default ProtectedRoutes

